import { useEffect, useRef, useState } from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import CheckerDivider from "../components/CheckerDivider";
import hatProductFront from "../assets/hat-product-front.png";
import hatProductBack from "../assets/hat-product-back.jpg";
import hatLifestyleOutdoor from "../assets/hat-lifestyle-outdoor.jpg";
import hatLifestyeFlatlay from "../assets/hat-lifestyle-flatlay.png";
import hatEllenLifestyle from "../assets/hat-ellen-lifestyle.png";

const COMPONENT_NODE_ID = "product-component-1782872625133";

const GALLERY = [
  { src: hatProductFront,     alt: "AI Needs a Mother hat — front view" },
  { src: hatProductBack,      alt: "AI Needs a Mother hat — back, that's girl code" },
  { src: hatLifestyleOutdoor, alt: "AI Needs a Mother hat — lifestyle outdoor" },
  { src: hatLifestyeFlatlay,  alt: "AI Needs a Mother hat — lifestyle flat lay" },
  { src: hatEllenLifestyle,   alt: "AI Needs a Mother hat — worn by Ellen" },
];

const DETAILS = [
  "Cream & burgundy two-tone structured cap",
  "Embroidered lettering in our signature burgundy",
  "One size fits most — adjustable snapback",
  "Limited first run — once they're gone, they're gone",
];

const BTN: React.CSSProperties = {
  position: "absolute",
  top: "50%",
  transform: "translateY(-50%)",
  width: "32px",
  height: "32px",
  borderRadius: "50%",
  background: "#571310",
  border: "none",
  color: "#fffcef",
  fontSize: "18px",
  lineHeight: 1,
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 10,
  transition: "background-color 0.2s ease",
};

export function Shop() {
  const [active, setActive] = useState(0);
  const initialized = useRef(false);

  function prev() { setActive((i) => (i === 0 ? GALLERY.length - 1 : i - 1)); }
  function next() { setActive((i) => (i === GALLERY.length - 1 ? 0 : i + 1)); }

  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;

    function ShopifyBuyInit() {
      const ShopifyBuy = (window as any).ShopifyBuy;
      const client = ShopifyBuy.buildClient({
        domain: "rne0dp-md.myshopify.com",
        storefrontAccessToken: "254fb93f3f4bf3fae4961294220bb30a",
      });

      ShopifyBuy.UI.onReady(client).then(function (ui: any) {
        ui.createComponent("product", {
          id: "15102972297588",
          node: document.getElementById(COMPONENT_NODE_ID),
          moneyFormat: "%24%7B%7Bamount%7D%7D",
          options: {
            product: {
              styles: {
                product: { "text-align": "left" },
                button: {
                  "font-family": "Montserrat, sans-serif",
                  color: "#fffcef",
                  ":hover": { color: "#fffcef", "background-color": "#94201b" },
                  "background-color": "#571310",
                  ":focus": { "background-color": "#94201b" },
                  "border-radius": "7px",
                  "padding-left": "42px",
                  "padding-right": "42px",
                },
              },
              layout: "vertical",
              contents: {
                img: false,
                imgWithCarousel: false,
                title: false,
                price: false,
                description: false,
                button: false,
                buttonWithQuantity: true,
              },
              width: "100%",
              text: { button: "Add to cart" },
              googleFonts: ["Montserrat"],
            },
            modalProduct: {
              contents: {
                img: false,
                imgWithCarousel: true,
                button: false,
                buttonWithQuantity: true,
              },
              styles: {
                button: {
                  "font-family": "Montserrat, sans-serif",
                  color: "#fffcef",
                  ":hover": { color: "#fffcef", "background-color": "#94201b" },
                  "background-color": "#571310",
                  ":focus": { "background-color": "#94201b" },
                  "border-radius": "7px",
                  "padding-left": "42px",
                  "padding-right": "42px",
                },
              },
              googleFonts: ["Montserrat"],
              text: { button: "Add to cart" },
            },
            option: {},
            cart: {
              styles: {
                button: {
                  "font-family": "Montserrat, sans-serif",
                  color: "#fffcef",
                  ":hover": { color: "#fffcef", "background-color": "#94201b" },
                  "background-color": "#571310",
                  ":focus": { "background-color": "#94201b" },
                  "border-radius": "7px",
                },
                title: { color: "#000000" },
                header: { color: "#000000" },
                lineItems: { color: "#000000" },
                subtotalText: { color: "#000000" },
                subtotal: { color: "#000000" },
                notice: { color: "#000000" },
                currency: { color: "#000000" },
                close: { color: "#000000", ":hover": { color: "#000000" } },
                empty: { color: "#000000" },
                noteDescription: { color: "#000000" },
                discountText: { color: "#000000" },
                discountIcon: { fill: "#000000" },
                discountAmount: { color: "#000000" },
                cart: { "background-color": "#fffcef" },
                footer: { "background-color": "#fffcef" },
              },
              text: { total: "Subtotal", button: "Checkout" },
              googleFonts: ["Montserrat"],
            },
            toggle: {
              styles: {
                toggle: {
                  "font-family": "Montserrat, sans-serif",
                  "background-color": "#571310",
                  ":hover": { "background-color": "#94201b" },
                  ":focus": { "background-color": "#94201b" },
                },
                count: { color: "#fffcef", ":hover": { color: "#fffcef" } },
                iconPath: { fill: "#fffcef" },
              },
              googleFonts: ["Montserrat"],
            },
            lineItem: {
              styles: {
                variantTitle: { color: "#000000" },
                title: { color: "#000000" },
                price: { color: "#000000" },
                fullPrice: { color: "#000000" },
                discount: { color: "#000000" },
                discountIcon: { fill: "#000000" },
                quantity: { color: "#000000" },
                quantityIncrement: { color: "#000000", "border-color": "#000000" },
                quantityDecrement: { color: "#000000", "border-color": "#000000" },
                quantityInput: { color: "#000000", "border-color": "#000000" },
              },
            },
          },
        });
      });
    }

    function loadScript() {
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js";
      (document.getElementsByTagName("head")[0] || document.getElementsByTagName("body")[0]).appendChild(script);
      script.onload = ShopifyBuyInit;
    }

    const ShopifyBuy = (window as any).ShopifyBuy;
    if (ShopifyBuy) {
      ShopifyBuy.UI ? ShopifyBuyInit() : loadScript();
    } else {
      loadScript();
    }
  }, []);

  return (
    <div className="min-h-screen bg-cream flex flex-col">
      <Nav />

      <section className="flex-1 px-6 sm:px-10 md:px-[8%] py-14 md:py-20 bg-cream">
        <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16 items-start">

          {/* ── Left: Gallery ── */}
          <div>
            {/* Main image with arrow buttons */}
            <div style={{ position: "relative", background: "#fffcef", aspectRatio: "1/1", maxHeight: "55vh", overflow: "hidden", marginBottom: "12px" }}>
              <img
                key={active}
                src={GALLERY[active].src}
                alt={GALLERY[active].alt}
                style={{ width: "100%", height: "100%", objectFit: "contain", animation: "fadeIn 0.3s ease both" }}
              />
              {GALLERY.length > 1 && (
                <>
                  <button
                    aria-label="Previous image"
                    onClick={prev}
                    style={{ ...BTN, left: "10px" }}
                    onMouseEnter={e => ((e.currentTarget as HTMLElement).style.backgroundColor = "#94201b")}
                    onMouseLeave={e => ((e.currentTarget as HTMLElement).style.backgroundColor = "#571310")}
                  >
                    ‹
                  </button>
                  <button
                    aria-label="Next image"
                    onClick={next}
                    style={{ ...BTN, right: "10px" }}
                    onMouseEnter={e => ((e.currentTarget as HTMLElement).style.backgroundColor = "#94201b")}
                    onMouseLeave={e => ((e.currentTarget as HTMLElement).style.backgroundColor = "#571310")}
                  >
                    ›
                  </button>
                </>
              )}
            </div>

            {/* Thumbnails */}
            <div style={{ display: "grid", gridTemplateColumns: `repeat(${GALLERY.length}, 1fr)`, gap: "8px" }}>
              {GALLERY.map((img, i) => (
                <button
                  key={i}
                  type="button"
                  onClick={() => setActive(i)}
                  aria-label={img.alt}
                  aria-pressed={i === active}
                  style={{
                    aspectRatio: "1",
                    background: "#fffcef",
                    border: `2px solid ${i === active ? "#6d0016" : "transparent"}`,
                    overflow: "hidden",
                    padding: 0,
                    cursor: "pointer",
                    transition: "border-color 0.2s ease",
                  }}
                >
                  <img
                    src={img.src}
                    alt={img.alt}
                    style={{ width: "100%", height: "100%", objectFit: "cover", opacity: i === active ? 1 : 0.55, transition: "opacity 0.2s ease" }}
                  />
                </button>
              ))}
            </div>
          </div>

          {/* ── Right: Product info + Shopify buy button ── */}
          <div className="md:sticky md:top-24 flex flex-col">
            <p className="font-mono text-dustyrose uppercase" style={{ fontSize: "11px", letterSpacing: "0.22em", marginBottom: "1rem" }}>
              New Drop · That's Girl Code
            </p>
            <h1 className="font-playfair font-black text-stone-800 leading-tight" style={{ fontSize: "clamp(2rem, 5vw, 3rem)", marginBottom: "1.125rem" }}>
              AI Needs a{" "}
              <span className="font-script font-normal text-burgundy" style={{ fontSize: "1.15em" }}>Mother</span>
            </h1>
            <p className="font-montserrat font-semibold text-stone-800" style={{ fontSize: "22px", marginBottom: "1.5rem" }}>
              $35.00
            </p>
            <div className="font-montserrat text-stone-600 leading-relaxed" style={{ fontSize: "14px", marginBottom: "1.75rem", display: "flex", flexDirection: "column", gap: "14px" }}>
              <p>AI can go wrong in a lot of ways — and the best safeguard is a diverse set of voices in the room.</p>
              <p>One voice in particular: women. Because the models being built today reflect the rooms they were built in — and those rooms need us in them.</p>
              <p>The "AI Needs a Mother" hat makes you an advocate for safe AI, for women in tech, and for women <em>in</em> safe AI. Wear it. Make it known.</p>
            </div>
            <ul className="font-montserrat text-stone-500" style={{ fontSize: "13px", marginBottom: "2rem", display: "flex", flexDirection: "column", gap: "8px" }}>
              {DETAILS.map((d) => (
                <li key={d} style={{ display: "flex", alignItems: "flex-start", gap: "10px" }}>
                  <span className="text-burgundy" style={{ marginTop: "1px", flexShrink: 0 }}>—</span>
                  {d}
                </li>
              ))}
            </ul>

            {/* Shopify buy button only — no images, title, price, or description */}
            <div id={COMPONENT_NODE_ID} />
          </div>
        </div>
      </section>

      <CheckerDivider size={28} colorA="#fffcef" colorB="#1a0a0a" />

      <section style={{ background: "#1a0a0a" }} className="px-6 py-12 text-center">
        <p className="font-montserrat uppercase" style={{ fontSize: "11px", letterSpacing: "0.18em", color: "rgba(255,252,239,0.4)", marginBottom: "10px" }}>
          Questions? Sizing? Bulk orders?
        </p>
        <a
          href="https://instagram.com/thatsgirlcodepod"
          target="_blank"
          rel="noopener noreferrer"
          className="font-montserrat font-semibold text-dustyrose hover:text-cream focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-dustyrose"
          style={{ fontSize: "13px", letterSpacing: "0.1em", transition: "color 0.2s ease" }}
        >
          @thatsgirlcodepod →
        </a>
      </section>

      <Footer />
    </div>
  );
}
